import styled, { css } from "styled-components";

const styleExtension = () => {
  return css`
    border: 1px solid ${({ theme }) => theme?.colors?.primary.default};
    color: ${({ theme }) => theme?.colors?.white};
    background-color: ${({ theme }) => theme?.colors?.primary.tint2};
  `;
};

export const Container = styled.button`
  ${({
    // @ts-expect-error TS(2339): Property 'size' does not exist on type 'Omit<Detai... Remove this comment to see the full error message
    size,
  }) => css`
    width: ${size}px;
    height: ${size}px;
  `}

  background-color: ${({ theme }) => theme?.colors?.primary.surface};
  border: 1px solid ${({ theme }) => theme?.colors?.primary.default};
  border-radius: 50%;
  color: ${({ theme }) => theme?.colors?.primary.default};
  font-weight: 700;
  outline: unset;
  margin-bottom: 12px;
  cursor: pointer;

  ${({
    // @ts-expect-error TS(2339): Property 'selected' does not exist on type 'Omit<D... Remove this comment to see the full error message
    selected,
  }) => selected && styleExtension}
`;
